@if (application) {
  <div class="form-sidebar-container">
    <div
      class="form-sidebar-header"
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
    >
      <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between top">
        <div>
          <h3
            #panelHeading
            cdkFocusRegionStart
            tabindex="-1"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            {{ application.displayTitle }}
          </h3>
          <span class="subtitle"
            >Submitted
            {{ application.completedDate | date: 'mediumDate' }}</span
          >
        </div>
        <button
          mat-icon-button
          class="close-button"
          aria-label="Close Panel"
          (click)="close()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div class="form-sidebar-body">
      @if (
        (systemFields && systemFields.length > 0) ||
        (customFields && customFields.length > 0)
      ) {
        <ng-scrollbar>
          <div
            class="form-details"
            tabindex="0"
            role="region"
            aria-label="Form field responses"
          >
            @if (systemFields && systemFields.length > 0) {
              @if (isFirmForm) {
                <h4 class="section-heading">Firm Information</h4>
              }
              <div class="field-group">
                @for (field of systemFields; track field.key) {
                  <div class="system-field">
                    <b
                      class="field-label"
                      [innerHTML]="field.key | safeHtml"
                    ></b>
                    <div
                      class="field-value"
                      [ngClass]="{ 'no-value': !field.value }"
                      [innerHTML]="field.value || 'Did not answer' | safeHtml"
                    ></div>
                    <mat-divider class="divider"></mat-divider>
                  </div>
                }
              </div>
            }
            @if (customFields && customFields.length > 0) {
              @if (isFirmForm) {
                <h4 class="section-heading">Form Responses</h4>
              }
              @for (field of customFields; track field.name) {
                <div class="field-group">
                  <b
                    class="field-label"
                    [innerHTML]="field.name | safeHtml"
                  ></b>
                  <div
                    class="field-value"
                    [ngClass]="{ 'no-value': !field.value }"
                    [innerHTML]="field.value || 'Did not answer' | safeHtml"
                  ></div>
                  <mat-divider class="divider"></mat-divider>
                </div>
              }
            }
          </div>
        </ng-scrollbar>
      } @else {
        <p class="no-response-label">No responses.</p>
      }
    </div>
  </div>
}
